module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/RiceQ/Nagano_RiceQ_MIROC5_RCP85_Now.png";